module.exports = __webpack_public_path__ + "static/img/diastasis-recti.48eff3ee.png";